import { useQuery } from "@tanstack/react-query";
import { aniversariantesService } from "@/core/services/aniversariantesService";

/** Aniversariantes da Semana (Início) — recalcula sozinho a cada visita; sem cache entre domingos. */
export function useAniversariantesDaSemana() {
  return useQuery({
    queryKey: ["aniversariantes-da-semana"],
    queryFn: aniversariantesService.listarDaSemana,
  });
}
